import styled from 'styled-components';

const StyledMap = styled.div`
.google-map-container {
    position:relative;
    left:50%;
    transform:translate3d(-50%,0,0);
    height:50vh;
    width: calc(100vw - 7vw) ;
}
@media screen and (min-width: 600px){
    .google-map-container {
    position:relative;
    left:33.5%;
    transform:translate3d(-50%,0,0);
    height:50vh;
    width: 52% ;
    aspect-ratio: 16 / 4;   
}
}
`;

export default StyledMap